var map = {
	"./1234.jpg": "5911",
	"./b.jpg": "cdaf",
	"./d.jpg": "d57e",
	"./download.jpg": "9b77",
	"./login-2.png": "0df62",
	"./login-3.png": "7df2",
	"./login-4.png": "d5ac",
	"./光谷华为.png": "b7c2",
	"./华为城堡.png": "0141",
	"./大自然.png": "e331",
	"./海边.png": "46d7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6dd9";